<template>
  <fieldset class="day-picker">
    <legend class="subject-picker__legend u-screen-reader-only">Subject</legend>

    <template v-for="d in days">
      <input
        type="radio"
        :key="`input-${d}`"
        :id="weekday(d)"
        :value="shortISO(d)"
        name="date"
        class="day-picker__input"
        v-model="inputDate"
        @change="$emit('input', inputDate)"
      />

      <label
        :key="`label-${d}`"
        :for="weekday(d)"
        class="day-picker__label"
        :class="{'is-today': isToday(d)}"
      >
        <span class="day-picker__day">{{ d | weekday }}</span>
        <span class="day-picker__date">{{ d | monthDay }}</span>
      </label>
    </template>
  </fieldset>
</template>

<script>
import thisWeek from '@/utils/this-week'

export default {
  name: 'DayPicker',

  props: {
    value: {
      type: String,
      default: function () {
        return this.shortISO()
      }
    }
  },

  data () {
    return {
      days: thisWeek,
      inputDate: ''
    }
  },

  methods: {
    isToday (date) {
      return this.shortISO() === this.shortISO(date)
    },

    shortISO (date) {
      return this.$options.filters.shortISO(date)
    },

    weekday (date) {
      return this.$options.filters.weekday(date)
    }
  },

  mounted () {
    this.inputDate = this.value
  }
}
</script>

<style lang="scss">
.day-picker {
  margin: 1rem auto 2rem;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: .5rem;
  border: 0;
}

.day-picker__input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.day-picker__label {
  padding: .25rem .5rem;
  border-radius: 1.5rem;
  text-align: center;
  color: var(--color-page-fg);
  background-color: #CFD8DC;
  border: .125rem solid #CFD8DC;

  &:hover,
  &:active {
    border-color: #78909C;
  }

  &.is-today {
    box-shadow:
      0 0 0 .125rem #fff;
  }

  :focus + & {
    outline: none;
    box-shadow:
      0 0 0 .125rem var(--color-page-bg),
      0 0 0 .25rem #78909C;
  }

  :checked + & {
    border-color: currentColor;
  }
}

.day-picker__day {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
}

.day-picker__date {
  display: block;
  font-size: .8rem;
  font-weight: normal;
}
</style>
